/**
 * Object containing error code strings returned by the API.
 */
export const API_ERROR_CODES = Object.freeze({
    DUPLICATE_ACCOUNT: 'DuplicateAccount',
    CLAIMED_DOCUMENT: 'ClaimedDocument',
});
